import React from "react";
import Banner from "./Banner";
// import ReactCardSlider from "./ReactCardSlider";
import Eventmain from "./newseventsection/Eventmain";

// import ReactCardSlider from 'react-card-slider-component';
// import { Carousel } from 'react-carousel-minimal';
import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import AdmissionBanner from "./AdmissionBanner";

const Home = () => {
  // const sliderClick = (slider) => { };

  // const slides = [
  //   {
  //     image: "./images/cr1.jpg",
  //     title: "Merry Christmas",
  //     description: "25 December",
  //     clickEvent: sliderClick
  //   },
  //   {
  //     image: "/images/new1.jpg",
  //     title: "Happy New Year",
  //     description: "01 January ",
  //     clickEvent: sliderClick
  //   },

  //   {
  //     image: "./images/mk.jpg",
  //     title: "Happy Makar sankranti",
  //     description: "14 January ",
  //     clickEvent: sliderClick
  //   },

  //   {
  //     image: "./images/rep.jpg",
  //     title: "Republic Day",
  //     description: "26 January",
  //     clickEvent: sliderClick
  //   },
  //   {
  //     image: "./img/yoga.jpeg",
  //     title: "Happy Mahashivratri",
  //     description: "18 February",
  //     clickEvent: sliderClick
  //   },
  //   {
  //     image: "./images/fa.jpeg",
  //     title: "Happy Holi",
  //     description: "8 March",
  //     clickEvent: sliderClick
  //   },

  //   {
  //     image: "./images/g33.jpeg",
  //     title: "Mahavir Jayanti",
  //     description: "4 April ",
  //     clickEvent: sliderClick
  //   },

  //   {
  //     image: "./img/yoga.jpeg",
  //     title: "Celebrating Yoga Day",
  //     description: "21 june",
  //     clickEvent: sliderClick
  //   },
  //   {
  //     image: "./img/cultural.jpeg",
  //     title: "Cultural Activity",
  //     description: "yearly",
  //     clickEvent: sliderClick
  //   }
  // ];
  return (
    <>

      <AdmissionBanner />

      <Banner />

      <div className="new-div">
        {/* <div className="content_box"> */}
        <div className="Academy">
          {/* <div className="first_box bxx"> */}

          <div className="first-box">
            <h1 >Founder</h1>

            <div className="">
              <img src="./founder.jpeg" alt="founder" />
            </div>
            <div className="">
              <p
              // style={{
              //   fontStyle: "italic",
              //   fontSize: "20",
              //   color: "#000000"
              // }}
              >
                DEAR PARENTS,
                It is heartening to see the progress that Bhopal Academy has made since its inception in 1996. The vision of our founders, Shri Shivcharan and Smt. Chatro Devi Kushwaha, was to provide quality education to the children of Bhopal and its surrounding areas, and we are proud to continue that legacy.
                At Bhopal Academy, we believe that education is not just about imparting knowledge,

                <Link to="/principal"> read more</Link>
              </p>
            </div>
          </div>


          <div className="first-box" id="vissionimg">
            <h1
            //  style={{ color: "#000" }}
            >
              Vision{" "}
            </h1>

            {/* <div className="image_boxAb img-school"> */}

            <img className="vissionimg" src="./vission.jpeg" alt="vission" />


            {/* <div className="para-content"> */}

            <p
            // style={{
            //   fontStyle: "italic",
            //   fontSize: "20",
            //   color: "#000000"
            // }}
            >
              "We mentor each child to become an achiever in life. The school recognizes the importance of instilling moral values in students, helping them grow into responsible and valuable citizens of Bharat and the world. Additionally, we emphasize the values of tolerance and unity, empowering students to contribute to a strong, free, and harmonious India and beyond."
              {/*   <Link to="/ourSchool">read more</Link> */}
            </p>

          </div>

          <div className="first-box" >
            <h1 >Mission</h1>

            <div className="">
              <img src="./mission.png" alt="missin" />
            </div>
            <div className="">
              <p
              // style={{
              //   fontStyle: "italic",
              //   fontSize: "20",
              //   color: "#000000"
              // }}
              >
                The mission of Bhopal Academy Co-Ed Hr. Sec. School is to inspire, encourage, and guide its students to achieve academic and personal excellence. The school aims to provide a nurturing environment that fosters learning and personal growth, making education a lifelong and enjoyable experience for students.

                We strive to be a professional, dynamic, and energetic institution that upholds the vision for which it was established by the Shivdeep Shiksha Avam Samaj Kalyan Samiti over the past 29 years.

                {/*    <Link to="/principal">read more</Link> */}
              </p>
            </div>
          </div>
          {/* <div className="third_box bxx">
          <div className="bx1">
            <p>Latest From</p>
            <h1>Notice Board</h1>
          </div>

          <div className="image_boxAbc">
            <div className="animatinct" style={{ padding: "5px" }}>
              <p>1. Class Prep Admission Guideline 2023-24</p>
              <p>2. School Transport Arrangement</p>
              <p>3. School Transport Arrangement</p>
              <p>4. School Transport Arrangement</p>
              <p>5. School Transport Arrangement</p>
            </div>
          </div>
        </div> */}
        </div>


        <Eventmain />

        <div className="fourth_content_box">
          <div className="fouthmain">
            <div className="fourthOne">
              <div className="ffone">
                <h3>Photo Gallery</h3>
              </div>
              <div className="ffslider">
                <Carousel className="abcd">
                  <Carousel.Item className="jhk">
                    <img
                      className="d-block"
                      src="./photogallery1.jpg"
                      alt="First slide"
                    />
                  </Carousel.Item>
                  <Carousel.Item className="jhk">
                    <img
                      className="d-block"
                      src="./photogallery2.jpg"
                      alt="Second slide"
                    />
                  </Carousel.Item>

                  <Carousel.Item className="jhk">
                    <img
                      className="d-block"
                      src="./photogallery3.jpg"
                      alt="Third slide"
                    />
                  </Carousel.Item>

                  <Carousel.Item className="jhk">
                    <img
                      className="d-block"
                      src="./photogallery4.jpg"
                      alt="Third slide"
                    />
                  </Carousel.Item>
                </Carousel>
              </div>
              <div className="ffbutton">
                <Link to="/gallery">
                  <button>View More</button>
                </Link>
              </div>
            </div>
            <div className="fourthOne">
              <div className="ffone">
                <h3>Video Gallery</h3>
              </div>
              <div className="ffslider">


                <iframe
                  width="100%"
                  height="100%"
                  src="https://schoolerp-bucket.blr1.cdn.digitaloceanspaces.com/websites-img-videos/bhopal-academy/video.mp4"
                  title="Video Gallery"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen >
                </iframe>

              </div>
              <div className="ffbutton">
                <a
                  href="https://www.facebook.com/share/r/1Bu7JFoRgt/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button>View More</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
